Vue.component("UserMenu", {
    template:`
        <div class="UserMenu">

            <button v-if="loggedIn" @click="onLogout">logout</button>
            <button v-else          @click="onLogin">login</button>


            <h1 v-if="loggedIn">{{username}}</h1>


        </div>
    `,

    data () {
        return {
            username: app.authentication.userData.getData().username
        }
    },

    mounted () {
        this.eventHandlers = {
            "authorization-state-changed": () => {
                this.username = app.authentication.userData.getData().username
            }
        }
        app.radio.$on("authorization-state-changed", this.eventHandlers["authorization-state-changed"]);
    },
    destroyed () {
        app.radio.$off("authorization-state-changed", this.eventHandlers["authorization-state-changed"]);
    },
    computed: {
        loggedIn () {
            return this.$store.getters.loggedIn;
        },
    },
    methods: {
        onLogout () {
            this.$nextTick().then(()=> {

                app.authentication.logout();
            })

        },
        onLogin () {
            app.radio.$emit("show-login-dialogue")
        }
    }
})